import { render, staticRenderFns } from "./charmAction.vue?vue&type=template&id=7fd06ca1"
import script from "./charmAction.vue?vue&type=script&lang=js"
export * from "./charmAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd06ca1')) {
      api.createRecord('7fd06ca1', component.options)
    } else {
      api.reload('7fd06ca1', component.options)
    }
    module.hot.accept("./charmAction.vue?vue&type=template&id=7fd06ca1", function () {
      api.rerender('7fd06ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/action/charmAction.vue"
export default component.exports